/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ISitePickerViewProps } from '@msdyn365-commerce-modules/site-picker';
import { ISitePickerResources } from '../definition-extensions/site-picker.ext.props.autogenerated';

interface ISitePickerViewPropsExt extends ISitePickerViewProps {
    resources: ISitePickerResources;
}

export default (props: ISitePickerViewPropsExt) => {
    return <>{_renderSitePicker(props)}</>;
};

const _renderDesktopView = (props: ISitePickerViewPropsExt) => {
    const { SitePickerMenu } = props;
    return (
        <>
            <Node {...SitePickerMenu} onClick={props.renderSiteOptions} />
            {props.siteOptionsState ? _renderSiteOptionsList(props) : null}
        </>
    );
};

const _renderSiteOptionsList = (props: ISitePickerViewPropsExt): React.ReactNode => {
    const { SitePickerMenuList, SitePickerMenuListItem, SitePickerMenuListItemArray } = props;
    const options = SitePickerMenuListItemArray!.map((item, index) => {
        return (
            <Node {...SitePickerMenuListItem} key={index}>
                {item}
            </Node>
        );
    });
    return (
        <Node {...SitePickerMenuList}>
            <p>{props.resources.sitePickerReadContentLabel}</p>
            {options}
        </Node>
    );
};

const _renderMobileView = (props: ISitePickerViewPropsExt): React.ReactNode => {
    const { SitePickerMobileContainer, SitePickerMenuList, SitePickerMenuListItem } = props;
    const fixedSitePickerMobileContainer = {
        ...SitePickerMobileContainer,
        toggleButtonText: undefined
    };

    return (
        <Node {...fixedSitePickerMobileContainer} onClick={props.renderSiteOptions}>
            <Node {...SitePickerMenuList}>
                <p>{props.resources.sitePickerReadContentLabel}</p>
                {props.SitePickerMenuListItemArray?.map((item, index) => {
                    return (
                        <Node {...SitePickerMenuListItem} key={index}>
                            {item}
                        </Node>
                    );
                })}
            </Node>
        </Node>
    );
};

const _renderSitePicker = (props: ISitePickerViewPropsExt): React.ReactNode => {
    const { isMobileView, SitePicker } = props;
    return <Module {...SitePicker}>{isMobileView ? _renderMobileView(props) : _renderDesktopView(props)}</Module>;
};
